// 文件相当于支持的配置项，以此为主
export default {
  'env': 'development',
  'appID': 'intl-gcloud',
  'userID': '-',
  'consoleURL': '',
  'userURL': '',
  'websiteURL': '',
  'woaContactPerson': '',
  'websiteSwitchConfig': {
    'en': '',
    'zh-cn': ''
  },
  'languageConfig': {
    'currentLanguage': 0,
    'languageList': [
      {
        'area': '',
        'items': [
          {
            'name': '',
            'key': '',
            'link': ''
          }
        ]
      }
    ]
  },
  'copyRight': {
    'copyRightText': '',
    'protocolLinks': {}
  },
  'cookieName': 'DEV_INTL_GCLOUD_TICKET',
  'aegisConfig': {
    'enable': false,
    'id': '',
    'hostUrl': ''
  },
  'legalTerms': {
    'enabledCookieTips': true,
    'dataTransferProtocol': {
      'enabled': true,
      'url': '',
      'label': ''
    },
    'privacyPolicyProtocol': {
      'enabled': true,
      'url': '',
      'label': ''
    },
    'termsOfServiceProtocol': {
      'enabled': true,
      'url': '',
      'label': ''
    }
  },
  'captchaTencent': {
    'appID': '',
    'scriptURL': ''
  }
}



// WEBPACK FOOTER //
// ./src/config/config.default.js